import { useLayoutEffect, type RefObject } from 'react';

import { ORIENTATION } from '../../../chart-layout/types/constants.js';
import { useOrientation } from '../context/RangeLegendOrientationContext.js';

interface useLegendSegmentsItemOverlayProps {
  overlayRectRef: RefObject<SVGRectElement>;
  itemX: number;
  itemY: number;
}

export const useLegendSegmentsItemOverlay = ({
  itemX,
  itemY,
  overlayRectRef,
}: useLegendSegmentsItemOverlayProps) => {
  const { orientation } = useOrientation();
  const isHorizontal = orientation === ORIENTATION.Horizontal;

  useLayoutEffect(() => {
    if (overlayRectRef.current) {
      const containerGroup = overlayRectRef.current.closest('g');

      if (containerGroup) {
        const {
          height: parentHeight,
          width: parentWidth,
          y: parentY,
          x: parentX,
        } = containerGroup.getBBox();

        if (isHorizontal) {
          overlayRectRef.current.setAttribute(
            'height',
            parentHeight.toString(),
          );
          overlayRectRef.current.setAttribute('y', parentY.toString());
        } else {
          overlayRectRef.current.setAttribute('width', parentWidth.toString());
          overlayRectRef.current.setAttribute('x', parentX.toString());
        }
      }
    }
  }, [isHorizontal, itemX, itemY, overlayRectRef]);
};
